import { NavioLicensePlate } from '../CarDetails/Cards/NavioLicensePlate';

type Props = {
  carName: string;
  licensePlateNumber: string;
  /** The driver fact for this car — who holds it now, or who it is coming from. */
  note?: string;
};

/**
 * One car, shaped the same in the picker, the review and the outcome panel: model
 * left, plate right, the driver fact underneath. Three different row layouts for the
 * same object across three steps is what made the flow look assembled rather than designed.
 */
export const CarChangeRow = ({ carName, licensePlateNumber, note }: Props) => (
  <div className='flex min-w-0 flex-col gap-1'>
    <div className='flex min-w-0 items-center gap-2'>
      <p className='min-w-0 flex-1 truncate text-sm font-medium'>{carName}</p>
      <NavioLicensePlate car={{ licensePlateNumber }} className='shrink-0' />
    </div>
    {note && <p className='truncate text-xs text-muted-foreground'>{note}</p>}
  </div>
);
